import React from 'react';
import styled from 'styled-components';
import { Grid, Divider } from '@mui/material';
import { APPLICATION_TEXT } from '../../lang';
import { Checkbox, LabelValue } from '../../../../../components';
import type { ProgrammeChoiceFormData } from '../../../../Application/graphql';
import { getOptionsLabel } from '../../getOptionsLabel';
import {
  modeOfStudyOptions,
  programmeOptions,
  programmeTypeOptions,
} from '../../../../Application/components';

type ProgrammeChoiceFormProps = {
  data?: ProgrammeChoiceFormData;
};

const PROGRAM_CHOICE_TEXT = APPLICATION_TEXT.PROGRAMME_CHOICE;
export const ProgrammeChoiceForm: React.FunctionComponent<
  ProgrammeChoiceFormProps
> = (props: ProgrammeChoiceFormProps) => {
  const { data } = props;

  const {
    entryYear,
    studyMode = '',
    department,
    programme = '',
    programmeType = '',
    partner,
    isDualOrCollaborative = false,
    researchArea,
    proposedChiefSupervisor = 'N/A',
    researchAreaBackup,
    proposedChiefSupervisorBackup,
    acceptNoResearchIndicator = false,
  } = data ?? {};

  const renderData = [
    {
      label: PROGRAM_CHOICE_TEXT.ENTRY_YEAR,
      value: entryYear,
      isFullWidth: false,
    },
    {
      label: PROGRAM_CHOICE_TEXT.PROGRAMME,
      value: getOptionsLabel(programmeOptions, programme),
      isFullWidth: false,
    },
    {
      label: PROGRAM_CHOICE_TEXT.MODE_OF_STUDY,
      value: getOptionsLabel(modeOfStudyOptions, studyMode),
      isFullWidth: true,
    },
    {
      label: PROGRAM_CHOICE_TEXT.DEPARTMENT,
      value: department,
      isFullWidth: true,
    },
    {
      label: PROGRAM_CHOICE_TEXT.RESEARCH_AREA,
      value: researchArea,
      isFullWidth: true,
    },
    {
      label: PROGRAM_CHOICE_TEXT.RESEARCH_AREA_OPTIONAL,
      value: researchAreaBackup,
      isFullWidth: true,
    },
    {
      label: PROGRAM_CHOICE_TEXT.PROPOSED_CHIEF_SUPERVISOR,
      value: proposedChiefSupervisor,
      isFullWidth: true,
    },
    {
      label: PROGRAM_CHOICE_TEXT.PROPOSED_CHIEF_SUPERVISOR_OPTIONAL,
      value: proposedChiefSupervisorBackup,
      isFullWidth: true,
    },
    {
      label: PROGRAM_CHOICE_TEXT.INTEND_ACCEPT,
      value: (
        <Checkbox
          label=""
          disabled
          value={acceptNoResearchIndicator}
          size="small"
        />
      ),
      isFullWidth: true,
    },
    {
      label: PROGRAM_CHOICE_TEXT.PROGRAMME_TYPE,
      value: getOptionsLabel(programmeTypeOptions, programmeType),
      isFullWidth: true,
    },
    {
      label: PROGRAM_CHOICE_TEXT.DUAL_PHD,
      value: (
        <Checkbox
          label=""
          disabled
          value={isDualOrCollaborative}
          size="small"
        />
      ),
      isFullWidth: true,
    },
    ...(isDualOrCollaborative
      ? [
          {
            label: PROGRAM_CHOICE_TEXT.UNIVERSITY_CATEGORY,
            value: partner?.universityCategory ?? 'N/A',
            isFullWidth: true,
          },
          {
            label: PROGRAM_CHOICE_TEXT.IS_POLYU_HOME,
            value: (
              <Checkbox
                label=""
                disabled
                value={partner?.isPolyUHomeUniversity as boolean}
                size="small"
              />
            ),
            isFullWidth: true,
          },
          {
            label: PROGRAM_CHOICE_TEXT.PARTNER_INSTITUTION,
            value:
              partner?.university !== undefined && partner?.university !== ''
                ? partner?.university
                : 'N/A',
            isFullWidth: true,
          },
          {
            label:
              PROGRAM_CHOICE_TEXT.PROPOSED_CHIEF_SUPERVISOR_OF_PARTNER_INSTITUTION,
            value:
              partner?.proposedChiefSupervisor !== undefined &&
              partner?.proposedChiefSupervisor !== ''
                ? partner?.proposedChiefSupervisor
                : 'N/A',
            isFullWidth: true,
          },
          {
            label: PROGRAM_CHOICE_TEXT.APPLICATION_NO_OF_PARTNER_INSTITUTION,
            value:
              partner?.partnerUniversityApplicationNo !== undefined &&
              partner?.partnerUniversityApplicationNo !== ''
                ? partner?.partnerUniversityApplicationNo
                : 'N/A',
            isFullWidth: true,
          },
        ]
      : []),
  ];

  return (
    <Container>
      <Grid container spacing={2} padding={1}>
        {renderData.map((item, index) => {
          return (
            <Grid key={index} size={item.isFullWidth ? 12 : 6}>
              <LabelValue label={item.label} value={item.value} />
              <Divider />
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 1rem;
  padding-bottom: 2rem;
  width: 100%;

  .MuiBox-root {
    padding: 0 0 0.1rem 0.5rem;
  }

  .MuiGrid-item {
    padding-left: 0 !important;
  }

  .MuiGrid-container {
    padding: 0.5rem 1rem 0 2rem !important;
  }
`;
